import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'solicitudes/';
export const getCategoriasDeQuejas = async () => {
  try {
    const response = await API.get(`${baseURI}categorias-de-las-quejas/`);
    // dispatch(setCategoriasDeQuejas(response.data));
    return response.data;
  } catch (error) {
    onError(error);
  }
  return [];
};

export const getMotivosDeQuejas = async () => {
  try {
    const response = await API.get(`${baseURI}motivos-de-las-quejas/`);
    // dispatch(setMotivosDeQuejas(response.data));
    return response.data;
  } catch (error) {
    // _logger(error);
    onError(error);
  }
  return [];
};

export const getSubmotivos = async () => {
  try {
    const response = await API.get(`${baseURI}sub-motivos-de-quejas/`);
    return response.data;
  } catch (error) {
    onError(error);
  }
  return [];
};

export const getEvidencias = async (params) => {
  try {
    const response = await API.get('solicitudes/archivos-de-quejas', { params });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};
